import { PublicPageHeader } from '@/_components';

export default function Loading() {
  return <PublicPageHeader title="Referral Program" description="Your Information" />;
}
